import React, { useState, useEffect } from "react"
import * as m5 from '@mobiscroll/react5'
import { getTradeFee, getTax, getBorrowStockFee, getInterest } from './Transaction'

const FeeEditor = ({ theme, transData, creditData, onCancel, onSet }) => {

    const [type, setType] = useState('normal')
    const [fee, setFee] = useState(0)
    const [tax, setTax] = useState(0)
    const [sfee, setSfee] = useState(0)
    const [interest, setInterest] = useState(0)
    const [dealer, setDealer] = useState(null)
    const [dcErrMsg, setDcErrMsg] = useState('')
    const [mfrErrMsg, setMfrErrMsg] = useState('')
    const [mfErrMsg, setMfErrMsg] = useState('')
    const [mtrErrMsg, setMtrErrMsg] = useState('')
    const [ssrErrMsg, setSsrErrMsg] = useState('')
    const [bsfErrMsg, setBsfErrMsg] = useState('')

    useEffect(() => {
        if (transData != null) {
            setDealer(transData.dealer)
            setTax(transData.tax)
            setSfee(transData.sfee)
            setInterest(transData.interest)
            setFee(transData.fee) //總費用
        }
    }, [transData])

    useEffect(() => {
        if (transData != null && dealer != null) {
            const isOkay = check()

            if (isOkay) {
                const { dc, mfr, mf } = dealer
                const tfee = getTradeFee(transData, dc, mfr, mf)
                const tax = getTax(transData)
                setTax(tax)
                if (transData.credit) {
                    const sfee = getBorrowStockFee(transData, dealer.bsf)
                    transData.dealer = dealer
                    const interest = getInterest(creditData, transData)
                    setSfee(sfee)
                    setInterest(interest)
                    setFee(tfee + tax + sfee + interest)
                } else {
                    transData.dealer = dealer
                    setFee(tfee + tax)
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dealer, transData])

    const updateDealer = (ev) => {
        let newDealer = { ...dealer }
        switch (ev.target.name) {
            case 'minFee':
            case 'minFeeR':
                newDealer[ev.target.name] = ev.target.value === '' ? '' : parseInt(ev.target.value)
                break
            default:
                newDealer[ev.target.name] = ev.target.value === '' ? '' : parseFloat(ev.target.value)
        }

        setDealer(newDealer)

    }


    const check = () => {
        let isOkay = true

        const { dc, mfr, mf, mtr, ssr, bsf } = dealer
        if (dc <= 1 && dc > 0) {
            setDcErrMsg('')
        } else {
            isOkay = false
            setDcErrMsg('折數介於0~1')
        }
        if (mfr <= 20 && mfr > 0) {
            setMfrErrMsg('')
        } else {
            isOkay = false
            setMfrErrMsg('應介於1~20元')
        }
        if (mf <= 20 && mf > 0) {
            setMfErrMsg('')
        } else {
            isOkay = false
            setMfErrMsg('應介於1~20元')
        }
        if (transData.credit) {
            if (mtr < 100 && mtr > 0) {
                setMtrErrMsg('')
            } else {
                isOkay = false
                setMtrErrMsg('請設定合理利率')
            }
            if (ssr < 100 && ssr > 0) {
                setSsrErrMsg('')
            } else {
                isOkay = false
                setSsrErrMsg('請設定合理利率')
            }
            if (bsf < 100 && bsf > 0) {
                setBsfErrMsg('')
            } else {
                isOkay = false
                setBsfErrMsg('請設定合理費率')
            }
        }
        return isOkay
    }

    const dcPopupBtns = [
        {
            text: '取消',
            cssClass: 'float-left',
            handler: onCancel
        },
        {
            text: '確定',
            handler: () => {

                const isOkay = check()
                const { dc, mfr, mf, mtr, ssr, bsf } = dealer
                let cfee = document.getElementById("select-dealer-cFee").value
                if (cfee !== '') {
                    cfee = parseInt(cfee)
                }

                if (isOkay) {
                    let newDealer = {
                        ...transData.dealer,
                        dc,
                        mfr,
                        mf
                    }
                    if (transData.credit) {
                        newDealer = {
                            ...newDealer,
                            mtr,
                            ssr,
                            bsf
                        }
                    }
                    onSet(newDealer, cfee)
                }
            }
        }
    ]

    const withInterest = transData && transData.credit &&
        ((transData.creditType === 'short' && transData.action === 'buy')
            || (transData.creditType === 'long' && transData.action === 'sell'))

    return (
        <m5.Popup isOpen={transData !== null} buttons={dcPopupBtns}>
            {(transData && dealer) &&
                <>
                    {transData.credit &&
                        <div className="pr-4">
                            <m5.SegmentedGroup name="type" onChange={(ev) => { setType(ev.target.value) }}>
                                <m5.Segmented value="normal" defaultChecked={type === 'normal'}>一般交易</m5.Segmented>
                                <m5.Segmented value="credit" defaultChecked={type === 'credit'}>信用交易</m5.Segmented>
                            </m5.SegmentedGroup>
                        </div>}
                    {type === 'normal' ?
                        <>
                            <h6>{dealer.name} 手續費折數</h6>
                            <m5.Input inputStyle="box" name="dc" type="number" placeholder="ex:6折 請填0.6"
                                error={dcErrMsg !== ''} errorMessage={dcErrMsg} value={dealer.dc} onChange={updateDealer}></m5.Input>
                            <h6>零股最低手續費</h6>
                            <m5.Input inputStyle="box" name="mfr" type="number" placeholder="1~20"
                                error={mfrErrMsg !== ''} errorMessage={mfrErrMsg} value={dealer.mfr} onChange={updateDealer}></m5.Input>
                            <h6>整股最低手續費</h6>
                            <m5.Input inputStyle="box" name="mf" type="number" placeholder="1~20"
                                error={mfErrMsg !== ''} errorMessage={mfErrMsg} value={dealer.mf} onChange={updateDealer}></m5.Input>
                        </> :
                        <>
                            <h6>融資利率(%)</h6>
                            <m5.Input inputStyle="box" name="mtr" type="number" placeholder="一般介於 5~7"
                                error={mtrErrMsg !== ''} errorMessage={mtrErrMsg} value={dealer.mtr} onChange={updateDealer} />
                            <h6>融券利率(%)</h6>
                            <m5.Input inputStyle="box" name="ssr" type="number" placeholder="一般介於 0.1~0.4"
                                error={ssrErrMsg !== ''} errorMessage={mtrErrMsg} value={dealer.ssr} onChange={updateDealer} />
                            <h6>借券費(%)</h6>
                            <m5.Input inputStyle="box" name="bsf" type="number" placeholder="一般為 0.08"
                                error={bsfErrMsg !== ''} errorMessage={mtrErrMsg} value={dealer.bsf} onChange={updateDealer} />
                        </>
                    }
                    <h6>自動計算費用</h6>
                    <div className={'my-3 mx-3 alert alert-' + theme + ' alert-ext-' + theme} >
                        折讓後手續費 {fee - tax - sfee} <br /> 税費 {tax} <br />
                        {
                            (transData.creditType === 'short' && transData.action === 'sell') &&
                            <>借券費 {sfee} <br /></>
                        }
                        {
                            withInterest ? <>
                                {
                                    transData.creditType === 'short' && transData.action === 'buy' ?
                                        <>利息收入 {interest}<br /><b>合計費用 {fee + interest} </b></>
                                        : transData.creditType === 'long' && transData.action === 'sell' ?
                                            <>利息支出 {interest}<br /><b>合計費用 {fee + interest} </b></> :
                                            ''
                                }
                            </> : <b>合計費用 {fee} </b>
                        }
                    </div>
                    <h6>自行輸入費用</h6>
                    <m5.Input inputStyle="box" id="select-dealer-cFee" type="number"
                        defaultValue={transData.cfee}></m5.Input>
                </>}
        </m5.Popup>
    )
}

export default FeeEditor
